import React,{useState,useEffect} from 'react';
import { Link ,useLocation} from 'react-router-dom';
import { ArrowRightOutlined } from '@ant-design/icons';
import moment from 'moment';
import * as Styled from './style.js';
import {getData } from '../../config/api-connect';
import {  Table, Spin,Skeleton } from 'antd';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer,BarChart,Bar} from 'recharts';
import Spinner from '../../components/spinner'

const LeadsProcessed = ({leadsProcessedRef, month, year,cities,venues,venueId  }) => {
    const location = useLocation();
    const [graphData,setGraphData] = useState([])
    const [loading, setLoading] = useState(true)
    const [pageLoading, setPageLoading] = useState(true)
    const [leadDetails, setLeadDetails] = useState([])
    const [heading, setHeading] = useState([])

    useEffect(()=>{
      getVenue()
      if(cities !== ''){
        getLeadsProcessed()
      }
    },[cities,venueId,month,year])

    const lead_processed = heading.filter(col => col !== 'venue_id').map(col => ({
        title: col.charAt(0).toUpperCase() + col.slice(1).replace(/_/g, ' '),
        dataIndex: col,
        key: col,
        sorter: col === 'total' ? (a, b) => a.total - b.total : false,
        align: col !== 'venue' && 'center',
        render: col === 'venue' ? 
        (text, record) => (
            <Link to={`/leadsProcessed/?venue_id=${record.venue_id}`} className='venueTitle'>
                {record.venue}
            </Link>
        )
        : 
        text => text
    }))
    .concat([
        {
        title: '',
        dataIndex: 'venue_id',
        key: 'action',
        render: (value) => (
            <Link to={`/leadsProcessed/?venue_id=${value}`} className="venueTitle">
                <ArrowRightOutlined />
            </Link>
        ),
        align: 'center'
        }
    ]);

    const getGraphData = async (venue,cities) => {
      setLoading(true)
      await getData(`/business/get_leads_graph/?venue_id=${venue}&city_id=${cities}&month=${month}&year=${year}&lead_type=leads_processed`)
      .then(response =>{
        setGraphData(response.result)
      })
      .catch(error => {
        console.log(error.message);
      })
      .finally(()=>{
        setLoading(false)
      })
    }

    const getVenue = async() => {
      let choosenVenue = 'All'
      let choosenCity = 'All'
      if(venueId) {
        choosenVenue = venueId
      }
      if(cities) {
        choosenCity = cities.join(',')
      }
      getGraphData(choosenVenue,choosenCity)
    }

    const getLeadsProcessed = async () => {
      setPageLoading(true)
      var venue = get_venue_ids_for_report_api()
      var date = year + '-' + month + '-01'
      await getData(`/eagleeye/getTableDataJSON/?report_id=750761&venue_id=${venue}&date=${date}`)
      .then(response =>{
        setHeading(response.headers)
        setLeadDetails(response.data)  
        setPageLoading(false)
      })
      .catch(error => {
        setPageLoading(false)
      });
    }

    const get_venue_ids_for_report_api = () =>{
      var venue = ''
      if(venueId == 'All'){
        if(cities){
          var venue = cities
          if(cities.length > 1){
            const venue_in_city = venues.filter(item => cities.includes(item.city));
            const locationIds = venue_in_city.map(v => v.location);
            var venue = locationIds.join(',');
          }
        }
      }
      else{
        var venue = venueId
      }

      if(venue == 'All'){
        var venue = 0
      }

      return venue;
    }

    return (
      <div ref={leadsProcessedRef}>
        <Styled.Header>          
            <span>Leads Processed - {moment(month, 'MM').format('MMMM') + ' ' + year}</span>
        </Styled.Header>

        <Styled.BarGraphContainer>
          <Styled.GraphDiv>
            <Styled.GraphDivLabelDiv>
              <Styled.LabelHeading> Demos - Analysis </Styled.LabelHeading>          
            </Styled.GraphDivLabelDiv>

            {loading ? (
              <div style={{ height: '28vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <Spin />
              </div>
            ) : graphData && graphData.length > 0 ? (
              (() => {
                const graph_data = graphData;
                return (
                  <ResponsiveContainer width="100%" height="80%">
                    <BarChart width={400} height={400} data={graph_data} margin={{top: 5, right: 10, left: 5, bottom: 5}}>
                      <CartesianGrid strokeDasharray="3 3" />
                      <XAxis dataKey="month" tickFormatter={(value) => moment(value, "MMMM YYYY").format("MMM")}/>
                      <YAxis />
                      <Tooltip />
                      <Legend />
                      <Bar type="monotone" dataKey="demo_scheduled" fill="#c48e1a" name="Demo Scheduled"/>
                      <Bar type="monotone" dataKey="demo_attended" fill="#1e7c0a" name="Demo Attended"/>
                    </BarChart>
                  </ResponsiveContainer>
                );
              })()
            ) : null}
          </Styled.GraphDiv>
          <span></span>
          <Styled.GraphDiv>
            <Styled.GraphDivLabelDiv>
              <Styled.LabelHeading> Leads Processed - Analysis </Styled.LabelHeading>          
            </Styled.GraphDivLabelDiv>

            {loading ? (
              <div style={{ height: '28vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <Spin />
              </div>
            ) : graphData && graphData.length > 0 ? (
              (() => {
                const graph_data = graphData;
                return (
                  <ResponsiveContainer width="100%" height="80%">
                    <LineChart width={400} height={400} data={graph_data} margin={{top: 5, right: 10, left: 5, bottom: 5}}>
                      <CartesianGrid strokeDasharray="3 3" />
                      <XAxis 
                        dataKey="month" 
                        tickFormatter={(value) => moment(value, "MMMM YYYY").format("MMM")}
                      />
                      <YAxis/>
                      <Tooltip />
                      <Legend />
                      <Line type="monotone" dataKey="leads_processed" stroke="#4345ab" name="Leads Processed"/>  
                    </LineChart>
                  </ResponsiveContainer>
                );
              })()
            ) : null}
          </Styled.GraphDiv>
        </Styled.BarGraphContainer>
        {
          pageLoading ?
            <Skeleton active paragraph={{ rows: 7 }} title={false} />
          :  
          <Table
              className="ant-table-thead table_container"
              rowKey="id"
              columns={lead_processed}
              dataSource={leadDetails.map((row, index) => ({
              ...row,
              key: index,  
              }))}
              pagination={{ pageSize: 100, showSizeChanger: false}}
              summary={() => {
                  const totalRow = {};
                  const excludeKeys = ['venue', 'venue_id'];
                  const totalCount = leadDetails.length;

                  if (totalCount > 0) {
                    Object.keys(leadDetails[0]).forEach((key) => {
                      if (!excludeKeys.includes(key)) {
                        if (leadDetails[0][key]) {
                          const total = leadDetails.reduce((sum, item) => {
                            return sum + Number(item[key]);
                          }, 0);
                          totalRow[key] = total;                        
                        }
                      }
                    });
                  }
                  else{
                    return null
                  }
                  return (
                    <Table.Summary.Row>
                      {lead_processed.map((col, index) => {
                        const key = col.dataIndex;

                        if (index === 0) {
                          return (
                            <Table.Summary.Cell key={key}><b>Total</b></Table.Summary.Cell>
                          );
                        }

                        if (key === 'venue_id') {
                          return <Table.Summary.Cell key={key} />;
                        }

                        return (
                          <Table.Summary.Cell key={key} align="center">
                            {totalRow.hasOwnProperty(key) ? (
                              <b>{totalRow[key]}</b>
                            ) : ''}
                          </Table.Summary.Cell>
                        );
                      })}
                    </Table.Summary.Row>
                  );
                }}
          />
        }
      </div>
    );
};

export default LeadsProcessed;